import React from 'react';
import Icon from '../../../../components/icon';
import {Column, Row} from '../../../../components/layout';
import {Icons} from '../../../../util/icons';

export interface StatusProps {
  stateDescription: string | undefined;
  color: string | undefined;
}

function ReimbursementListItemStatus(props: StatusProps) {
  return (
    <Row className="flex-align-items-start">
      <Column className="reimbursement-history-list-item-status-label">
        {props.stateDescription?.toUpperCase()}
      </Column>
      <Column className="reimbursement-history-list-item-status-indicator-column">
        <Icon
          className="reimbursement-history-list-item-status-indicator"
          name={Icons.STATUS_INDICATOR}
          color={props.color}
          width={window.innerWidth < 768 ? '9' : '16'}
          height={window.innerWidth < 768 ? '9' : '16'}
          changeViewbox
          viewBox={'0 0 24 24'}
        />
      </Column>
    </Row>
  );
}

export default ReimbursementListItemStatus;
